<app-floorplan-product-menu
  [title]="tooltipTextDisplay"
  [hasConfigurations]="displays.length > 0"
  [visible]="floorplan.floorplanState.displaysVisible"
  [locked]="floorplan.floorplanState.displaysLocked"
  [itemTextVisible]="floorplan.floorplanState.displaysItemTextVisible"
  (visibilityUpdate)="floorplan.floorplanState.displaysVisible = $event"
  (lockUpdate)="floorplan.floorplanState.displaysLocked = $event"
  (itemTextVisibilityUpdate)="updateDisplaysItemTextVisibility($event)"
  (addPlaceholderToFloorplan)="addPlaceholder()"
  (dragPlaceholder)="dragPlaceholder()"
  configPath="display"
>
  @for (display of displays; track display) {
    <div>
      <hr />
      <app-configured-product
        [productConfiguration]="display"
        [imageUrl]="getImageUrl(display)"
        [fallbackImageUrl]="fallbackImageUrl"
        [numberOfFloorplanItems]="floorplan.countPlacedDisplays(display)"
        [attachments]="[]"
        (add)="addDisplay(display)"
        (delete)="deleteDisplay(display)"
        (dragStart)="drag(display)"
        editPath="display"
      >
      </app-configured-product>
    </div>
  }
</app-floorplan-product-menu>
